import {
  AnimalProductIntroFormValues,
  AnimalProductPriceFormValues,
} from "Components/Features/CheckPrice/Products/RiskProducts/Animal/animalInterfaces";
import {
  ANIMAL_INTRO_STEP,
  ANIMAL_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/Animal/animalSteps";
import {
  isDeathCoverageSelected,
  isVetCoverageSelected,
  mapAnimalCoverageToCoverageGroup,
} from "Components/Features/CheckPrice/Products/RiskProducts/Animal/animalUtils";

import { DEFAULT_COVERAGE_AMOUNT_DEATH } from "Components/Features/CheckPrice/Products/RiskProducts/Animal/animalConstants";
import { getSliderInputValue } from "Components/Form/Slider/sliderUtils";
import { VALUE_TYPE } from "Components/NumberValue";
import { CompanyTransferSpecifications } from "Store/interfaces/CompanyTransferSpecifications";
import { Species } from "Store/interfaces/products/checkout/riskProducts/AnimalProduct";
import { AnimalCoverageGroup } from "Store/interfaces/products/coverage";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products/index";
import { mapFormToInjuries } from "Store/priceCalculation/productMappers/common/injuriesMapper";
import { formBooleanToBoolean } from "Utils/formUtils";
import { format } from "date-fns";

export type AnimalProductBackend = {
  name: INSURANCE_NAME_VALUE;
  coverageGroup: AnimalCoverageGroup;
  species: Species;
  dateOfBirth: string;
  breed: string;
  microchipped: boolean;
  coverageAmountDeath: number;
  coverageAmountVet: number;
  damageCountRecentYears: number;
  companyTransferSpecifications: CompanyTransferSpecifications;
  yearOfLastDamage?: number;
  sliderInputCoverageAmountDeath: string;
};

export const mapToCommerceAnimal = (data: {
  [key: string]: any;
}): AnimalProductBackend => {
  const introFormValues: AnimalProductIntroFormValues =
    data.formData[`${ANIMAL_INTRO_STEP.id}`];
  const priceFormValues: AnimalProductPriceFormValues =
    data.formData[`${ANIMAL_PRICE_STEP.id}`];

  return {
    name: INSURANCE_NAME_VALUE.ANIMAL,
    coverageGroup: mapAnimalCoverageToCoverageGroup(priceFormValues.coverage),
    species: introFormValues.species,

    dateOfBirth: format(introFormValues.dateOfBirth, "yyyy-MM-dd"),
    breed: introFormValues.breed,
    microchipped: formBooleanToBoolean(introFormValues.microchipped),
    coverageAmountDeath: isDeathCoverageSelected(priceFormValues.coverage)
      ? Number(priceFormValues.coverageAmountDeath)
      : 0,
    coverageAmountVet: isVetCoverageSelected(priceFormValues.coverage)
      ? Number(priceFormValues.coverageAmountVet)
      : 0,
    companyTransferSpecifications: {
      insuranceShouldBeTransferredFromAnotherCompany: formBooleanToBoolean(
        introFormValues.insuranceShouldBeTransferredFromAnotherCompany,
      ),
    },
    sliderInputCoverageAmountDeath: getSliderInputValue(
      VALUE_TYPE.NOK,
      DEFAULT_COVERAGE_AMOUNT_DEATH,
      priceFormValues.coverageAmountDeath,
    ),
    ...mapFormToInjuries(introFormValues.injuries, introFormValues.injuryYear),
  };
};
